import { Injectable } from '@angular/core'
import { OAFollowersQuery } from './oa-follower.query'
import { OAFollowersStore } from './oa-follower.store'
import { ZaloAPI, ZaloApi } from '@etop/api/shop/zalo.api'
import { OAConnectionQuery } from '../oa-connection'
import { CursorPaging, Followers, TotalFollowers } from '@etop/models'

@Injectable({
    providedIn: 'root',
})
export class OAFollowersService {
    constructor(
        private store: OAFollowersStore,
        private query: OAFollowersQuery,
        private zaloApi: ZaloApi,
        private shopOAQuery: OAConnectionQuery
    ) {}

    async getListFollowers(getTotal = true) {
        this.setLoading(true);
        this.setLastPage(false);
        try {
            let listShopOA = this.shopOAQuery.getAll();
            if (listShopOA.length == 0) {
                this.store.set([]);
                return;
            }
            const { paging, filter } = this.query.currentUi;
            let _filter = {...filter};
            let res = await this.zaloApi.listFollowerOA({paging, filter: _filter});
            let followers: Followers[] = res.followers.map((f: Followers) => {
                return {
                   ...f,
                   created_at: new Date(f.created_at).getFullYear() == 1 ? null : f.created_at,
                   oa: listShopOA.find(oa => oa.oa_id === f.oa_id),

                }
            })
            this.setPaging(res.paging);
            this.store.set(followers);
            
            if (getTotal) {
                let sync = await this.zaloApi.getTotalFollowers(_filter.oa_id);
                this.setSync(sync);
            }

            if (followers.length == 0) {
                if (res.paging.next == "") {
                this.setLastPage(true);
                }
            } 
        } catch(e) {
            debug.error('ERROR in getFilterFollowersOA', e);
        }
        this.setLoading(false);

    }

    setPaging(paging: CursorPaging) {
        this.store.update({
            ui: {
            ...this.query.currentUi,
            paging,
            },
        });
    }

    setCurrentPage(currentPage: number) {
        this.store.update({
            ui: {
            ...this.query.currentUi,
            currentPage,
            },
        });
    }
    
    setFilter(filter: ZaloAPI.FilterFollowersOA) {
        this.store.update({
            ui: {
            ...this.query.currentUi,
            filter,
            },
        });
    }

    setSync(sync: TotalFollowers) {
        this.store.update({
            ui: {
                ...this.query.currentUi,
                sync,
            },
        });
    }

    setLoading(loading: boolean) {
        this.store.setLoading(loading);
    }

    setLastPage(isLastPage: boolean) {
        const ui = this.query.getValue().ui;
        this.store.update({
            ui: {
            ...ui,
            isLastPage
            }
        });
    }

    setActive(id: string) {
        this.store.setActive(id);
    }
}